import React from 'react';
import { Link } from 'react-router-dom';

interface CtaProps {
  label: string;
  to: string;
  variant: 'magenta' | 'outline';
}

interface HeroBlockProps {
  eyebrow: string;        // e.g. "● Home — building"
  headline: React.ReactNode;  // the h1 content — caller can include <i> for gradient-accent
  lede?: React.ReactNode;     // sub-headline paragraph
  ctas?: CtaProps[];          // optional CTA row
  heroClassName?: string;     // page-specific tweak class (e.g. "home-hero")
}

/**
 * Reused by HomeAi, ServicesAi, AboutAi, ContactAi. Renders the locked
 * outer rhythm chunk: eyebrow + h1 (with .gradient-accent on inline <i>)
 * + lede + optional CTA pair. Per RESEARCH.md the hero min-height uses
 * 100svh (Pitfall 3) — defined in ai.css.
 */
export const HeroBlock: React.FC<HeroBlockProps> = ({ eyebrow, headline, lede, ctas, heroClassName }) => (
  <section className={`ai-hero ${heroClassName ?? ''}`.trim()}>
    <div className="ai-hero-inner">
      <div className="eyebrow">{eyebrow}</div>
      <h1 className="ai-hero-h1">{headline}</h1>
      {lede && <p className="ai-hero-lede">{lede}</p>}
      {ctas && ctas.length > 0 && (
        <div className="ai-cta-row">
          {ctas.map(cta => (
            <Link
              key={cta.label}
              to={cta.to}
              className={cta.variant === 'magenta' ? 'btn-magenta' : 'btn-outline'}
            >
              {cta.label}
            </Link>
          ))}
        </div>
      )}
    </div>
  </section>
);

export default HeroBlock;
